import './PersonalInfo.css';
import React,{ useContext } from 'react';
import FormState from '../context/FormState';
import { uploadContactInformation } from '../helpers/firebase';
import styles from "./personalInfo.module.css";
import logo from "../../../assets/img/logo.png";
import Profile_img from "../../../assets/img/Profile_img.png";
function ContactInfo(props){
    const ctx=useContext(FormState);
    const submithandler=()=>{
        uploadContactInformation(ctx.contact,ctx.linkedin,ctx.country,ctx.state,ctx.address,ctx.pincode);
    }
    return (
        
     <React.Fragment>
     {/* <Header></Header> */}

     <div className={styles.container}>
       <div className={styles.left}>
         <div className={styles.imageContainer}>
           <img src={logo} alt="" />

           <div className={styles.logoDesc}>
             <p>VIT AP UNIVERSITY</p>
             <p className={styles.smallDes}>Alumni Association</p>
           </div>
         </div>

         {/* image kindha */}
         <div className={styles.sideNav}>
                  <div className={styles.navItem}>
                    <div className={styles.num}>1</div>
                    <div className={styles.pInfo}>
                      <p className={styles.pBigInfo}>Personal Information</p>
                      <p className={styles.psmallInfo}>Personal Profile Details</p>
                    </div>
                  </div>
      
                  <div className={styles.navItem}>
                    <div className={styles.num}>2</div>
      
                    <div className={styles.pInfo}>
                      <p className={styles.pBigInfo}>Educational Information</p>
                      <p className={styles.psmallInfo}>Courses/degrees pursued</p>
                    </div>
                  </div>
      
                  <div className={styles.navItem}>
                    <div className={styles.num}>3</div>
      
                    <div className={styles.pInfo}>
                      <p className={styles.pBigInfo}>Contact Details</p>
                      <p className={styles.psmallInfo}>Location and contact</p>
                    </div>
                  </div>
      
                  <div className={styles.navItem} style={{"opacity":"0.6"}}>
                    <div className={styles.num}>4</div>
      
                    <div className={styles.pInfo}>
                      <p className={styles.pBigInfo}>Work Details</p>
                      <p className={styles.psmallInfo}>Professional Details</p>
                    </div>
                  </div>
                </div>
       </div>

       <div className={styles.right}>
         <div className={styles.profile}>
           <div className={styles.userInfo}>
             <p className={styles.username}>Mervin Joseph</p>
             <p>VIT AP University</p>
           </div>
           <img
             src={Profile_img}
             alt="Profile Image"
             className={styles.profileImage}
           />
         </div>

         <h1>Contact Details</h1>

         <table className={styles.rightDesc}>
           <tr className={styles.rightItems} style={{"display":"table-row"}}>
             <td><p>Contact No</p></td>
             <td className={styles.radionCon}>
               <input type="text" />
             </td>
           </tr>
           <tr className={styles.rightItems} style={{"display":"table-row"}}>
           <td><p>LinkedIn Profile</p></td>
             <td className={styles.radionCon}>
               <input type="text" />
             </td>
           </tr>
           <tr className={styles.rightItems} style={{"display":"table-row"}}>
           <td><p>Country</p></td>
             <td className={styles.radionCon}>
               <input type="text" />
             </td>
           </tr>
           <tr className={styles.rightItems} style={{"display":"table-row"}}>
           <td><p>State</p></td>
             <td className={styles.radionCon}>
               <input type="text" />
             </td>
           </tr>
           <tr className={styles.rightItems} style={{"display":"table-row"}}>
           <td><p>Address</p></td>
             <td className={styles.radionCon}>
               <input type="text" />
             </td>
           </tr>
           <tr className={styles.rightItems} style={{"display":"table-row"}}>
           <td><p>Pin Code</p></td>
             <td className={styles.radionCon}>
               <input type="text" />
             </td>
           </tr>
         </table>

         {/* buttons */}
         <div className={styles.buttons}>
           <button className={styles.btn} onClick={ ()=>props.setStep("3")}>Back</button>
           <button className={styles.btn} onClick={()=> props.setStep("5")}>Next</button>
         </div>
       </div>
     </div>
   </React.Fragment>
    );
}
export default ContactInfo;